import "@hotwired/turbo";
import { Application } from "@hotwired/stimulus";
import Button from "./controllers/button_controller.js";
import Review from "./controllers/review_controller.js";
import Search from "./controllers/search_controller.js";
import ShareComponent from "./controllers/share_component_controller.js";
import BarcodeComponent from "./controllers/barcode_component_controller.js";
import ShareLocationComponent from "./controllers/share_location_component_controller.js";
import ImageASearchComponent from "./controllers/image_a_search_component_controller.js";
import ThemeModeComponent from "./controllers/theme_mode_component_controller.js";
import DynamicButtonComponent from "./controllers/dynamic_button_component_controller.js";
import CartUpdateComponent from "./controllers/cart_update_component_controller.js";
import CartCountLoadComponent from "./controllers/cart_count_load_component_controller.js";
import ToastComponent from "./controllers/toast_component_controller.js";
import DownloadComponent from "./controllers/download_component_controller.js";
import LogoutComponent from "./controllers/logout_component_controller.js";
import LoaderHideComponent from "./controllers/loader_hide_component_controller.js";

window.Stimulus = Application.start();

Turbo.session.drive = true;

Stimulus.register("bridge--button", Button);
Stimulus.register("bridge--review-prompt", Review);
Stimulus.register("bridge--search", Search);
Stimulus.register("bridge--share", ShareComponent);
Stimulus.register("bridge--barcode", BarcodeComponent);
Stimulus.register("bridge--location", ShareLocationComponent);
Stimulus.register("bridge--imagesearch", ImageASearchComponent);
Stimulus.register("bridge--thememode", ThemeModeComponent);
Stimulus.register("bridge--dynamicbutton", DynamicButtonComponent);
Stimulus.register("bridge--cartupdate", CartUpdateComponent);
Stimulus.register("bridge--cartload", CartCountLoadComponent);
Stimulus.register("bridge--toast", ToastComponent);
Stimulus.register("bridge--download", DownloadComponent);
Stimulus.register("bridge--logout", LogoutComponent);
Stimulus.register("bridge--loaderhide", LoaderHideComponent);

/**
 * Function to update the theme mode via localstorage info
 */
const wkfashion_auto_update_theme_mode = () => {
    setTimeout(() => {
        const btn = document.querySelector(
            "[data-controller='bridge--thememode']",
        );
        if (btn) {
            btn.click();
        }
    }, 100);
    const theme = localStorage.getItem("theme");
    if (theme === "dark") {
        document.documentElement.classList.add("dark", "wkfashion-widget-dark");
    } else if (theme === "light") {
        document.documentElement.classList.remove(
            "dark",
            "wkfashion-widget-dark",
        );
    }
};

document.addEventListener("turbo:render", () => {
    let varProduct = document.querySelector(".variations_form");
    if (!!varProduct) {
        if (!window.wcVariationScriptLoaded) {
            const script = document.createElement("script");
            script.src = wkhw_customForm.variation_url;
            script.onload = function () {
                window.wcVariationScriptLoaded = true;
                jQuery("form.variations_form").each(function () {
                    jQuery(this).wc_variation_form();
                });
            };
            document.body.appendChild(script);
        } else {
            // Already loaded, just reinitialize.
            jQuery("form.variations_form").each(function () {
                jQuery(this).wc_variation_form();
            });
        }
    }
    const result = localStorage.getItem("cartCount");
    let cartCount = 0;
    if (result === null || result === undefined) {
        cartCount = wkhw_customForm.cart_count || 0;
    } else {
        cartCount = parseInt(result) || 0;
    }
    localStorage.setItem("cartCount", cartCount);

    if (
        window.location.href === wkhw_customForm.checkout_url ||
        window.location.href === wkhw_customForm.cart_url
    ) {
        // Update checkout totals (shipping recalculation).
        if (typeof wc_country_select_params !== "undefined") {
            jQuery().wc_country_select && jQuery("body").wc_country_select();
        }
        const script = document.createElement("script");
        script.src = wkhw_customForm.country_select_js_url;
        document.body.appendChild(script);
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = wkhw_customForm.select2_css_url; // Your CSS file URL
        document.head.appendChild(link);
        initWooCommerceSelect2();
    }
});

document.addEventListener("turbo:before-render", function () {
    // Destroy Select2 before Turbo replaces the DOM
    jQuery("select.select2-hidden-accessible").select2("destroy");
});

// Function to safely re-initialize WooCommerce Select2 elements
function initWooCommerceSelect2() {
    jQuery("select").each(function () {
        const $select = jQuery(this);

        // Target WooCommerce Select2 fields only
        if (
            $select.hasClass("country_to_state") ||
            $select.hasClass("wc-enhanced-select")
        ) {
            // Destroy existing instance if already initialized
            if ($select.hasClass("select2-hidden-accessible")) {
                $select.select2("destroy");
            }

            // Initialize Select2
            $select.select2();
        }
    });
}

document.addEventListener("turbo:load", () => {
    wkfashion_auto_update_theme_mode();
    getCartCount();
});

function getCartCount() {
    const formData = new FormData();
    formData.append("action", "wkhw_get_cart"); // WordPress AJAX action
    formData.append("nonce", wkhw_customForm.nonce); // WordPress nonce

    // Send form data with Turbo
    fetch(wkhw_customForm.ajaxUrl, {
        method: "POST",
        body: formData,
        headers: {
            "X-Requested-With": "XMLHttpRequest",
        },
    })
        .then((response) => response.text()) // Use .text() to handle HTML response for Turbo
        .then((data) => {
            if (data) {
                localStorage.setItem(
                    "cartCount",
                    JSON.parse(data).data.cart_count,
                );
                const el = document.querySelector(
                    "[data-controller='bridge--cartload']",
                );
                if (el) {
                    el.click(); // Trigger native bridge
                }
            } else {
                localStorage.setItem("cartCount", "0");
            }
        })
        .catch((err) => console.error("Form submission error:", err));
}

window.requestUserLocationFromNative = function () {
    const el = document.querySelector("[data-controller='bridge--location']");
    if (el) {
        el.click(); // Trigger native location bridge via simulated click
    }
};
